import React from 'react';
import {
  Box,
  Typography,
  IconButton
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import TfiatDistributionTable from './TfiatDistributionTable';

const TfiatDistributionPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 4, minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
        <IconButton onClick={() => navigate('/admin/dashboard')} sx={{ color: 'primary.main' }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h4" fontWeight={700} color="primary">
          📊 Distribución de Tfiats - Vista Completa
        </Typography>
      </Box>

      {/* Tabla de Distribución */}
      <TfiatDistributionTable />
    </Box>
  );
};

export default TfiatDistributionPage;
